import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

import StyledFlexBox from './StyledFlexBox';

const FlexBox = ({
	onClick,
	onContextMenu,
	className,
	style,
	onDragEnter,
	onDragLeave,
	onDrop,
	display,
	flexDirection,
	flexWrap,
	justifyContent,
	alignItems,
	alignContent,
	data,
	children,
	id,
	tooltip,
	disabled
}) => {
	const onClickHandler = e => {
		onClick(e);
	};

	const onContextMenuHandler = e => {
		onContextMenu(e);
	};

	useEffect(() => {
		ReactTooltip.rebuild();
	}, [tooltip]);

	return (
		<>
			<StyledFlexBox
				$alignContent={alignContent}
				$alignItems={alignItems}
				$disabled={disabled || data['data-disabled']}
				$display={display}
				$flexDirection={flexDirection}
				$flexWrap={flexWrap}
				$justifyContent={justifyContent}
				className={`react__flex-box ${className}`}
				data-tip={tooltip}
				id={id}
				role='listbox'
				style={style}
				tabIndex='0'
				onClick={e => (!disabled ? onClickHandler(e) : {})}
				onContextMenu={e => (!disabled ? onContextMenuHandler(e) : {})}
				onDragEnter={e => (!disabled ? onDragEnter(e) : {})}
				onDragLeave={e => (!disabled ? onDragLeave(e) : {})}
				onDrop={e => (!disabled ? onDrop(e) : {})}
				{...data}
			>
				{children}
			</StyledFlexBox>
		</>
	);
};

FlexBox.propTypes = {
	display: PropTypes.oneOf(['flex', 'inline-flex']),
	flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	justifyContent: PropTypes.oneOf([
		'flex-start',
		'flex-end',
		'center',
		'space-between',
		'space-around',
		'space-evenly',
		'start',
		'end',
		'left',
		'right'
	]),
	alignItems: PropTypes.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline']),
	alignContent: PropTypes.oneOf([
		'flex-start',
		'flex-end',
		'center',
		'space-between',
		'space-around',
		'space-evenly',
		'stretch',
		'start',
		'end',
		'baseline'
	]),
	className: PropTypes.string,
	data: PropTypes.object,
	onClick: PropTypes.func,
	style: PropTypes.object,
	onContextMenu: PropTypes.func,
	onDragEnter: PropTypes.func,
	onDragLeave: PropTypes.func,
	onDrop: PropTypes.func,
	children: PropTypes.node,
	id: PropTypes.string,
	disabled: PropTypes.bool,
	tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

FlexBox.defaultProps = {
	display: 'flex',
	style: {},
	flexDirection: 'row',
	flexWrap: 'nowrap',
	justifyContent: 'flex-start',
	alignItems: 'flex-start',
	alignContent: 'flex-start',
	className: '',
	data: {},
	onClick: () => {},
	onContextMenu: () => {},
	onDragEnter: () => {},
	onDragLeave: () => {},
	onDrop: () => {},
	id: null,
	children: null,
	disabled: false,
	tooltip: []
};

export default FlexBox;
